import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
Copyright 2024 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { CapabilityPoller } from "./capabilityPoller.js";
import { ClientPrefix, Method } from "./http-api/index.js";
/**
 * Manages storing and periodically refreshing the server capabilities.
 */
export class RetentionPolicyService extends CapabilityPoller {
  constructor(logger, http) {
    var _this;
    super(logger, http, "retention policy");
    _this = this;
    /**
     * Fetches the latest server capabilities from the homeserver and returns them, or rejects
     * on failure.
     */
    _defineProperty(this, "fetch", /*#__PURE__*/_asyncToGenerator(function* () {
      var resp = yield _this.http.authedRequest(Method.Get, "/retention/configuration", undefined, undefined, {
        prefix: "".concat(ClientPrefix.Unstable, "/org.matrix.msc1763")
      });
      _this.cached = resp;
      return _this.cached;
    }));
  }
}
//# sourceMappingURL=retentionPolicy.js.map